import {getStore, setStore} from '@/util/store'
import {getDictionary} from '@/api/system/dict'

const dict = {
  state: {
    flowRoutes: getStore({name: 'flowRoutes'}) || {},
    dict: []
  },
  actions: {
    FlowRoutes({commit}) {
      return new Promise((resolve, reject) => {
        getDictionary({code: 'flow'}).then(res => {
          commit('SET_FLOW_ROUTES', res.data.data);
          resolve();
        }).catch(error => {
          reject(error)
        })
      })
    },
		getDict({state}, key) {
			try {
				const item = state.dict.find((val) => val.key == key);
				return item ? item.value : null;
			} catch (e) {
				return null;
			}
		},
		setDict({state}, {key, value}) {
			if (!key || typeof key !== 'string') {
				return;
			}
			state.dict.push({ key, value });
		},
		removeDict(key) {
			try {
				const index = this.dict.findIndex((item) => item.key === key);
				if (index !== -1) {
					this.dict.splice(index, 1);
					return true;
				}
			} catch (e) {
				return false;
			}
			return false;
		},
  },
  mutations: {
    SET_FLOW_ROUTES: (state, data) => {
      state.flowRoutes = data.map(item => {
        return {
          routeKey: `${item.code}_${item.dictKey}`,
          routeValue: item.remark,
        };
      });
      setStore({name: 'flowRoutes', content: state.flowRoutes})
    },
  }

};

export default dict;
